export default "__VITE_ASSET__JVw37hUf__"